export default {
  fees_your_fees: 'Your %{asset} fees',
  fees_asset: 'Asset',
  fees_payment_fee: 'Payment fee',
  fees_offer_fee: 'Offer fee',
  fees_withdrawal_fee: 'Withdrawal fee',
  fees_issuance_fee: 'Issuance fee',
  fees_invest_fee: 'Invest fee',
  fees_incoming_outgoing: 'Incoming & Outgoing',
  fees_outgoing: 'Outgoing',
  fees_incoming: 'Incoming',
  fees_fee_type: 'Fee type',
  fees_fixed: 'Fixed',
  fees_percent: 'Percent',
  fees_lower_bound: 'Lower bound',
  fees_upper_bound: 'Upper bound',
  fees_subtype: 'Subtype',
  fees_percent_fixed: 'Fee: %{percent}% + %{fixed} %{currency}',
  fees_will_charged: 'Your account will be charged with a total of %{willCharged} %{currency}',
  fees_load_fail: 'Failed to load fees'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/fees.js